/* @flow */
import Glyph from 'components/Glyph.jsx';
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/Progress.scss';

type Props = {
  glyph?: string,
  label?: string,
  percent: number,
};

class Progress extends React.Component {
  props: Props;

  static propTypes = {
    glyph: React.PropTypes.string,
    label: React.PropTypes.string,
    percent: React.PropTypes.number.isRequired,
  };

  renderGlyph() {
    const { glyph } = this.props;

    if (glyph) {
      // $FlowFixMe
      return <Glyph name={glyph} color="eclipse" size="xxxlarge" className="Progress-glyph" />;
    } else {
      return null;
    }
  }

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return <Text color="thunder" element="div" className="Progress-label">{label}…</Text>;
    } else {
      return null;
    }
  }

  render() {
    const { percent } = this.props;

    return (
      <div className="Progress">
        {this.renderGlyph()}
        <div className="Progress-bar">
          <div className="Progress-bar-value" style={{ width: `${percent}%` }} />
        </div>
        {this.renderLabel()}
      </div>
    );
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/components/Progress.jsx